<div class="d-block text-start small-texts">
  <p *ngFor="let small_text of smallTexts; let i = index"
     class="text-start small fw-normal mb-1"
     [class.d-flex]="small_text.indexOf('DFC-20') == -1 && small_text.indexOf(SmallTexts.NoticeUtilisation) ==
      -1"
     [class.smltxt-inline]="small_text.indexOf('DFC-20') != -1 || small_text.indexOf(SmallTexts.NoticeUtilisation) !=
      -1">
    <span [innerHtml]="i+1 + '.&nbsp;'"></span>
    <span [innerHtml]="small_text"></span>
  </p>
</div>
